module.exports = __webpack_public_path__ + "static/img/banner5.8d252138.png";